import { formatISO, format as formatFns } from "date-fns";
import { fr } from "date-fns/locale";

const options = { locale: fr };

// Reconstruit un Date dont les champs LOCAUX (jour/mois/année/heure) sont égaux aux champs UTC
// de la date source. Nécessaire car `formatFns` lit toujours les champs locaux : sans ça, une date
// calendaire encodée en minuit UTC (ex: "2026-04-02") s'affiche avec le jour de la veille dans les
// fuseaux négatifs (Antilles, Guyane...).
function toCalendarLocalDate(date: number | Date): Date {
  const d = new Date(date);
  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
}

// by providing a default string of 'PP' or any of its variants for `formatStr`
// it will format dates in whichever way is appropriate to the locale
export function format(date: number | Date, formatStr = "PP", log?: boolean) {
  const newDate = toCalendarLocalDate(date);
  if (log) {
    console.log({ newDate });
    console.log({ parsed: formatISO(newDate, { format: "extended" }) });
  }

  return formatFns(newDate, formatStr, options);
}

export function formatUTC(date: number | Date, formatStr = "PP") {
  return formatFns(toCalendarLocalDate(date), formatStr, options);
}
